<template>
  <div>
    <!-- 学校top5课程 -->
    <Echart :options="options" height="276px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        // newData = {
        //   xData: ['注意力', '认知', '情绪'],
        //   seriesData: [200, 100, 300],
        //   max: 300,
        //   color: '#DADC36'
        // };
        let max = newData.max * 1.2;
        let seriesData2 = new Array(newData.seriesData.length).fill(max); //[max, max, max];

        this.options = {
          title: {
            text: newData.school,
            x: "20",
            y: "20",
            textStyle: {
              fontSize: 20,
              fontWeight: 400,
              color: "#fff"
            }
          },
          grid: {
            top: "100",
            bottom: "22"
          },
          xAxis: {
            type: "category",
            data: newData.xData,
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            max: max,
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          series: [
            {
              // 柱的颜色
              // name: '课程开展次数',
              type: "pictorialBar",
              symbol: "fixed",
              symbolSize: [25, 10],
              symbolMargin: 2,
              symbolRepeat: "repeat",
              symbolBoundingData: 300,
              z: -10,
              data: newData.seriesData,
              itemStyle: {
                normal: {
                  color: newData.color
                }
              }
            },
            {
              // 替代颜色
              type: "bar",
              name: "",
              barWidth: "25",
              z: -11,
              data: seriesData2,
              itemStyle: {
                normal: {
                  color: "#06122A"
                }
              },
              label: {
                normal: {
                  formatter: params => {
                    return (
                      params.name +
                      "\n\n" +
                      newData.seriesData[params.dataIndex] +
                      "次"
                    );
                  },
                  fontSize: "12",
                  color: newData.color,
                  position: "top",
                  lineHeight: 8,
                  distance: "8",
                  show: true
                }
              }
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
